import React from 'react'

const ExpandOpen = (props) => (
  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" {...props}>
    <path d="M0.924316 1.07568L4.92432 7.07568L8.92432 1.07568" stroke="currentColor" strokeWidth="2" />
  </svg>
)

export default ExpandOpen
